// React
import React from "react";
import PropTypes from "prop-types";

const SelectedLanguage = ({ iconClass, onClick, text, ...props }) => (
  <a data-toggle="dropdown" onClick={onClick} style={{ cursor: 'pointer' }}>
    <i className={iconClass} />
    <span>
      &nbsp;
      {text}
      &nbsp;
    </span>
    <i className="fa fa-angle-down" />
  </a>
);

SelectedLanguage.defaultProps = {
  iconClass: "",
  onClick: () => { }
};

SelectedLanguage.propTypes = {
  iconClass: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string
};

export default SelectedLanguage;
